import type { Transport } from './types'

export type HttpMethod = 'GET' | 'POST'

/**
 * Create a thin, typed endpoint caller for a given method and path.
 *
 * Example:
 * const cancelOrder = endpoint<CancelOrder, SimpleResponse>('POST', '/order/cancel')
 * await cancelOrder(transport, { orderId: 123 })
 */
export function endpoint<Req = unknown, Res = unknown>(method: HttpMethod, path: string) {
  return async (transport: Transport, payload?: Req): Promise<Res> => {
    if (method === 'GET') {
      // For GET endpoints, payload is treated as query params
      return transport.get<Res>(path, payload as any)
    } else {
      return transport.post<Res>(path, payload as any)
    }
  }
}

/**
 * Convenience wrapper for GET endpoints.
 */
export function getEndpoint<Params = Record<string, any>, Res = unknown>(path: string) {
  return endpoint<Params, Res>('GET', path)
}

/**
 * Convenience wrapper for POST endpoints.
 */
export function postEndpoint<Req = unknown, Res = unknown>(path: string) {
  return endpoint<Req, Res>('POST', path)
}

